// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopArticlePagingResultModel from '../../model/shop-article-paging-result-model';
import ShopArticlePagingResultDTO from '../dto/shop-article-paging-result-dto';
import dtoSchema from '../schemas/shop-article-paging-result-schema';
import ShopArticleModel from '../../model/shop-article-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ShopArticlePagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopArticlePagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopArticleModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: ShopArticleModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<ShopArticlePagingResultDTO>): ShopArticlePagingResultModel;
  static toModel(dto: DeepPartial<ShopArticlePagingResultDTO> | undefined | null): ShopArticlePagingResultModel | undefined;
  static toModel(dto: DeepPartial<ShopArticlePagingResultDTO> | undefined | null): ShopArticlePagingResultModel | undefined {
    return dto ? new ShopArticlePagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopArticlePagingResultModel> | ShopArticlePagingResultModel): ShopArticlePagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as ShopArticlePagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopArticlePagingResultModel, can not map to ShopArticlePagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
